import React from 'react';
import * as Primitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from './utils';
import './dialog.css';

export const Dialog = Primitive.Root;
export const DialogTitle = Primitive.Title;
export const DialogDescription = Primitive.Description;
export const DialogContent = React.forwardRef(({ className, children, closeDisabled = false, ...props }, ref) => <Primitive.Portal>
  <Primitive.Overlay className="pegasus-dialog-overlay" />
  <Primitive.Content ref={ref} className={cn('pegasus-ui pegasus-dialog-content', className)} {...props}>
    {children}
    <Primitive.Close className="pegasus-dialog-close" disabled={closeDisabled} aria-label="Fermer la fenêtre"><X size={18} /></Primitive.Close>
  </Primitive.Content>
</Primitive.Portal>);
DialogContent.displayName = 'DialogContent';
